var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1022.4 253.2h-844.8c-45.602 0-81.602 37.199-81.602 81.602v530.4c0 45.602 37.199 81.602 81.602 81.602h844.8c45.602 0 81.602-37.199 81.602-81.602l-0.003906-530.4c0-45.602-37.199-81.602-81.602-81.602zm-15.598 48-352.8 352.8c-14.398 14.398-33.602 21.602-54 21.602s-39.602-8.3984-54-21.602l-352.8-352.8zm49.199 564c0 19.199-15.602 33.602-33.602 33.602h-844.8c-19.199 0-33.602-15.602-33.602-33.602v-530.4c0-4.8008 1.1992-8.3984 2.3984-13.199 0 0 1.1992 1.1992 1.1992 1.1992l364.8 364.8c22.801 22.801 54 36 87.602 36s63.602-13.199 87.602-36l364.8-364.8s1.1992-1.1992 1.1992-1.1992c1.1992 3.6016 2.3984 8.3984 2.3984 13.199z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.72d7bcd873858877a726d9acf54c2f1d.svg";
export { ForwardRef as ReactComponent };